import React from 'react';
import { Button } from 'components';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import theme from 'theme';

const Confirm = withStyles({
    root: {
        '& Button':{
            boxShadow: 'none !important',
        },
        '& .MuiDialogActions-root': {
            padding: '20px 0px 0px 0px',
            gap: '4px',
        },
        '& .MuiPaper-root': {
            [theme.breakpoints.up(768)]: {
                padding: '26px',
            },
            padding: '10px 0 20px 0',
        },
        '& .MuiDialogTitle-root': {
            paddingBottom: '0px',
            '& h2': {
                fontFamily: 'var(--font-heading)',
                fontWeight: '800',
            },
        },
        '& .MuiDialogContentText-root':{
            fontSize: '1rem',
        },
    },
})(Dialog);

export default function ConfirmDialog({ handleClose, onConfirm, open, text }) {


    const confirmHandler = () => {
        handleClose();
        onConfirm();
    };
    const cancelHandler = () => {
        handleClose();
    };

    return (
        <div>
            <Confirm
                open={ open }
                onClose={ handleClose }
                fullWidth = { true }
                maxWidth = "xs"
            >
                <DialogTitle >{ text.title }</DialogTitle>
                <DialogContent>
                    <DialogContentText >
                        { text.content }
                    </DialogContentText>
                    <DialogActions>
                        <Button variant="outline" onClick={ cancelHandler } >
                            { text.no }
                        </Button>
                        <Button onClick={ confirmHandler } >
                            { text.yes }
                        </Button>
                    </DialogActions>
                </DialogContent>
            </Confirm>
        </div>
    );
}

ConfirmDialog.propTypes = {
    handleClose: PropTypes.func,
    onConfirm: PropTypes.func,
    open: PropTypes.bool,
    text: PropTypes.object,
};
